import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Treeselect from '@riophae/vue-treeselect';
import Paginate from "vuejs-paginate";
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import PageTracker from '../../../common/PageTrackerHelper'

export default {
  name: 'UpdateShipmentDetails',
  components: {
      VueElementLoading,
      Treeselect,
      Paginate,
  },
  mixins:[PageTracker],
  data: function() {
      return {
          picked : "RTO",
          ShipmetIds : '',
          getHubObj : [],
          ddlHub : '',
          comments : '',
          groupedErrors : [],
          reasonObj : [{"ReasonsID" : "1","Reason":"change shipment status"},{"ReasonsID" : "2","Reason":"change shipment RTOToHub status"}],
          userDataKey : '',
      }
  },
  created: function() {
      this.getHubList();
  },
  async mounted(){
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);

    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.rolename = userdetail.userrole[0]['rolename'];
    this.hubdetails = userdetail.hubdetails[0];
    //console.log('this.hubdetails',this.hubdetails);

    // let TrackerInfo = {
    //     projectname:"Last Mile",
    //     type:"Web",
    //     userid:this.localuserid,
    //     username:this.localusermailid,
    //     meta: {
    //         "event":""
    //     }
    // }
  },
  methods : {
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          console.log('form submited');
          var shipmentidsarr = []
          var shippingids = this.ShipmetIds.split(',');
          for (var i = 0; i < shippingids.length; i++) {
            shipmentidsarr.push(`${shippingids[i]}`)
          }
          if(this.picked === 'RTO'){
            var updateAddress = {
                shippingID : shipmentidsarr,
                hubID : this.ddlHub,
                comments : this.comments,
                LastModifiedBy : this.localusermailid,
                currentHubID: this.hubdetails
            }
            axios.put(apiUrl.api_url + 'shipments/Update/ShiftBulkShipmentRTOToHub', updateAddress)
            .then((response) => {
              //console.log("response",response.data[0].message);
              console.log("response",response);
              this.groupedErrors = response.data;
              console.log('this.groupedErrors',this.groupedErrors);
              // if(response.data.code === 200){
              //   this.$alertify.success("Record Updated");
              // }
              // else {
              //     this.$alertify.error(response.data.message);
              // }

            })
          .catch((httpException) => {
              this.$alertify.error("Unable to Update Record");
              console.error('exception is:::::::::',httpException)
          });

        } else {
          var updateAddress = {
              shippingID : shipmentidsarr,
              hubId : this.ddlHub,
              comment : this.comments,
              userRole :this.rolename.toString(),
              userHubID :this.hubdetails,
              LastModifiedBy : this.localusermailid
          }
          console.log('DEstination', updateAddress);
          axios.put(apiUrl.api_url + 'UpdateShipment/ShiftbulkShipmentDestinationHub', updateAddress)
          .then((response) => {
            console.log("response",response.data);

            console.log("response",response);
            this.groupedErrors = response.data;
            console.log('this.groupedErrors',this.groupedErrors);
            // if(response.data.code === 200){
            //   this.$alertify.success("Record Updated");
            // }
            // else {
            //     this.$alertify.error(response.data.message);
            // }

          })
          .catch((httpException) => {
              this.$alertify.error("Unable to Update Record");
              console.error('exception is:::::::::',httpException)
          });
        }
          //console.log('Payload: ',updateAddress);
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    getHubList(){

       axios.get(apiUrl.api_url + 'shipmentMisrout/gethublist', {})
        .then((response) => {
            if(response.data.code===200){
                this.getHubObj =response.data.data;
            }
            else {
                this.getHubObj=[];
            }
        })
        .catch((httpException) => {
            this.$alertify.success("Hub data not found");
            console.error('exception is:::::::::', httpException)
        })

    },
    onlyNumber : function($event){
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
       if ((keyCode < 48 || keyCode > 57 ) && keyCode !== 8 && keyCode !== 44) {
          $event.preventDefault();
       }
    },
    clear(){
      this.ShipmetIds = '';
      this.ddlHub = '';
      this.comments = '';
      this.groupedErrors=[];
      this.$validator.reset();
      this.errors.clear();
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/ShiftShipment/ShiftShipment.component.js